import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: 'homePage',
      component: () => import(/*webpackChunkName: "homePage"*/ "@/page/homePage/homePage"),
    },
    {
      path: "/login",
      name: 'login',
      component: () => import(/*webpackChunkName: "homePage"*/ "@/page/login/login"),
    },
    // 应用场景
    {
      path: '/appScene',
      name: 'appScene',
      component: () => import(/*webpackChunkName: "appScene"*/ "@/page/appScene/appScene"),

    },
    {
      path: '/appBuilding',
      name: 'appBuilding',
      component: () => import(/*webpackChunkName: "appScene"*/ "@/page/appScene/appBuilding"),

    },
    {
      path: '/appUnderground',
      name: 'appUnderground',
      component: () => import(/*webpackChunkName: "appScene"*/ "@/page/appScene/appUnderground"),

    },
    {
      path: '/appIndustry',
      name: 'appIndustry',
      component: () => import(/*webpackChunkName: "appScene"*/ "@/page/appScene/appIndustry"),
    },
    {
      path: '/appcountry',
      name: 'appcountry',
      component: () => import(/*webpackChunkName: "appScene"*/ "@/page/appScene/appcountry"),

    },
    {
      path: '/appTraffic',
      name: 'appTraffic',
      component: () => import(/*webpackChunkName: "appScene"*/ "@/page/appScene/appTraffic"),
    },
    {
      path: '/appEnergy',
      name: 'appEnergy',
      component: () => import(/*webpackChunkName: "appScene"*/ "@/page/appScene/appEnergy"),
    },

    // 核心技术
    {
      path: '/sonar',
      name: 'sonar',
      component: () => import(/*webpackChunkName: "technology"*/ "@/page/technology/algorithm/sonar"),
    },
    {
      path: '/uav',
      name: 'uav',
      component: () => import(/*webpackChunkName: "technology"*/ "@/page/technology/algorithm/uav"),
    },
    {
      path: '/bigData_one',
      name: 'bigData_one',
      component: () => import(/*webpackChunkName: "technology"*/ "@/page/technology/algorithm/bigData_one"),
    },
    {
      path: '/bigData_two',
      name: 'bigData_two',
      component: () => import(/*webpackChunkName: "technology"*/ "@/page/technology/algorithm/bigData_two"),
    },
    {
      path: '/bigData_three',
      name: 'bigData_three',
      component: () => import(/*webpackChunkName: "technology"*/ "@/page/technology/algorithm/bigData_three"),
    },
    {
      path: '/bigData_four',
      name: 'bigData_four',
      component: () => import(/*webpackChunkName: "technology"*/ "@/page/technology/algorithm/bigData_four"),
    },
    {
      path: '/intelligence_one',
      name: 'intelligence_one',
      component: () => import(/*webpackChunkName: "technology"*/ "@/page/technology/algorithm/intelligence_one"),
    },
    {
      path: '/intelligence_two',
      name: 'intelligence_two',
      component: () => import(/*webpackChunkName: "technology"*/ "@/page/technology/algorithm/intelligence_two"),
    },
    {
      path: '/intelligence_three',
      name: 'intelligence_three',
      component: () => import(/*webpackChunkName: "technology"*/ "@/page/technology/algorithm/intelligence_three"),
    },
    {
      path: '/equipment',
      name: 'equipment',
      component: () => import(/*webpackChunkName: "technology"*/ "@/page/technology/equipment/equipment"),
    },

    // 自助服务
    {
      path: '/selfService',
      name: 'selfService',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/selfService"),
    },
    // 合作关系
    {
      path: '/partnership',
      name: 'partnership',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/partnership"),
    },
    {
      path: '/case_1',
      name: 'case_1',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_1"),
    },
    {
      path: '/case_2',
      name: 'case_2',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_2"),
    },
    {
      path: '/case_6',
      name: 'case_6',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_6"),
    },
    {
      path: '/case_7',
      name: 'case_7',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_7"),
    },
    {
      path: '/case_8',
      name: 'case_8',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_8"),
    },
    {
      path: '/case_9',
      name: 'case_9',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_9"),
    },
    {
      path: '/case_10_bridge_changxing',
      name: 'case_10_bridge_changxing',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_10_bridge_changxing"),
    },
    {
      path: '/case_11_bridge_moxigangongqiao',
      name: 'case_11_bridge_moxigangongqiao',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_11_bridge_moxigangongqiao"),
    },
    {
      path: '/case_12_bridge_qingshanhu',
      name: 'case_12_bridge_qingshanhu',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_12_bridge_qingshanhu"),
    },
    {
      path: '/case_13_changjiangdushi',
      name: 'case_13_changjiangdushi',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_13_changjiangdushi"),
    },
    {
      path: '/case_14_qinliangshan',
      name: 'case_14_qinliangshan',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_14_qinliangshan"),
    },
    {
      path: '/case_15_suzhougucheng',
      name: 'case_15_suzhougucheng',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_15_suzhougucheng"),
    },
    {
      path: '/case_16_gaosugongluwang',
      name: 'case_16_gaosugongluwang',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_16_gaosugongluwang"),
    },
    {
      path: '/case_17_underground_bimjikeng',
      name: 'case_17_underground_bimjikeng',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_17_underground_bimjikeng"),
    },
    {
      path: '/case_18_underground_bimditiesuidao',
      name: 'case_18_underground_bimditiesuidao',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_18_underground_bimditiesuidao"),
    },
    {
      path: '/case_19_underground_hangzhanlou',
      name: 'case_19_underground_hangzhanlou',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_19_underground_hangzhanlou"),
    },
    {
      path: '/case_20_bimbiandianzhan',
      name: 'case_20_bimbiandianzhan',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_20_bimbiandianzhan"),
    },
    {
      path: '/case_21_city_kangzheng',
      name: 'case_21_city_kangzheng',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_21_city_kangzheng"),
    },
    {
      path: '/case_22_building_ninghugaosu copy',
      name: 'case_22_building_ninghugaosu copy',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_22_building_ninghugaosu copy"),
    },
    {
      path: '/case_23_building_zhongshijidierqi',
      name: 'case_23_building_zhongshijidierqi',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_23_building_zhongshijidierqi"),
    },
    {
      path: '/case_24_building_shandongweifang',
      name: 'case_24_building_shandongweifang',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_24_building_shandongweifang")
    },
    {
      path: '/case_25_bridge_list',
      name: 'case_25_bridge_list',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_25_bridge_list")
    },
    {
      path: '/case_26_Industry_list',
      name: 'case_26_Industry_list',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_26_Industry_list")
    },
    {
      path: '/case_27_building_list',
      name: 'case_27_building_list',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_27_building_list")
    },
    {
      path: '/case_28_Traffic_list',
      name: 'case_28_Traffic_list',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_28_Traffic_list")
    },
    {
      path: '/case_29_Underground_list',
      name: 'case_29_Underground_list',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_29_Underground_list")
    },
    {
      path: '/case_30_Energy_list',
      name: 'case_30_Energy_list',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_30_Energy_list")
    },
    {
      path: '/case_31_country_list',
      name: 'case_31_country_list',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_31_country_list")
    },
    {
      path: '/case_32_algurithm_list',
      name: 'case_32_algurithm_list',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_32_algurithm_list")
    },
    {
      path: '/case_33_team_list',
      name: 'case_33_team_list',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_33_team_list")
    },
    {
      path: '/case_34_carbonemission',
      name: 'case_34_carbonemission',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_34_carbonemission")
    },
    {
      path: '/case_35_bridge_analysis',
      name: 'case_35_bridge_analysis',
      component: () => import(/*webpackChunkName: "selfService"*/ "@/page/selfService/case_35_bridge_analysis")
    },

    // 新闻资讯
    {
      path: '/newsInformation',
      name: 'newsInformation',
      component: () => import(/*webpackChunkName: "newsInformation"*/ "@/page/newsInformation/newsInformation"),
    },
    {
      path: '/news-detail-1',
      name: 'news-detail-1',
      component: () => import(/*webpackChunkName: "newsInformation"*/ "@/page/newsInformation/news-detail-1"),
    },
    {
      path: '/news-detail-2',
      name: 'news-detail-2',
      component: () => import(/*webpackChunkName: "newsInformation"*/ "@/page/newsInformation/news-detail-2"),
    },
    {
      path: '/news-detail-3',
      name: 'news-detail-3',
      component: () => import(/*webpackChunkName: "newsInformation"*/ "@/page/newsInformation/news-detail-3"),
    },
    {
      path: '/news-detail-4',
      name: 'news-detail-4',
      component: () => import(/*webpackChunkName: "newsInformation"*/ "@/page/newsInformation/news-detail-4"),
    },
    {
      path: '/news-detail-5',
      name: 'news-detail-5',
      component: () => import(/*webpackChunkName: "newsInformation"*/ "@/page/newsInformation/news-detail-5"),
    },
    {
      path: '/news-detail-6',
      name: 'news-detail-6',
      component: () => import(/*webpackChunkName: "newsInformation"*/ "@/page/newsInformation/news-detail-6"),
    },
    {
      path: '/news-detail-7',
      name: 'news-detail-7',
      component: () => import(/*webpackChunkName: "newsInformation"*/ "@/page/newsInformation/news-detail-7"),
    },
    {
      path: '/news-detail-8',
      name: 'news-detail-8',
      component: () => import(/*webpackChunkName: "newsInformation"*/ "@/page/newsInformation/news-detail-8"),
    },
    {
      path: '/news-detail-9',
      name: 'news-detail-9',
      component: () => import(/*webpackChunkName: "newsInformation"*/ "@/page/newsInformation/news-detail-9"),
    },
    {
      path: '/popular',
      name: 'popular',
      component: () => import("@/page/popular/popular"),
    },
    {
      path: '/popular_1',
      name: 'popular_1',
      component: () => import("@/page/popular/popular_1"),
    },
    {
      path: '/popular_2',
      name: 'popular_2',
      component: () => import("@/page/popular/popular_2"),
    },
    {
      path: '/popular_3',
      name: 'popular_3',
      component: () => import("@/page/popular/popular_3"),
    },
    {
      path: '/popular_3_1',
      name: 'popular_3_1',
      component: () => import("@/page/popular/popular_3_1"),
    },
    {
      path: '/popular_3_2',
      name: 'popular_3_2',
      component: () => import("@/page/popular/popular_3_2"),
    },
    {
      path: '/popular_3_3',
      name: 'popular_3_3',
      component: () => import("@/page/popular/popular_3_3"),
    },
  ],
  // 页面跳转到顶部
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js